console.log('IM HERE')



let flkty;

function initFlickity() {
  flkty = new Flickity('.tcw-mobile--slider ', {
    // Flickity options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    groupCells: false, 
    percentPosition: false, 
    pageDots: false,
    prevNextButtons: false
  });
}

function destroyFlickity() {
  if (flkty) {
    flkty.destroy();
    flkty = null;
  }
}

function checkWindowSize() {
  if ($(window).width() > 768) {
    destroyFlickity();
  } else {
    if (!flkty) {
      initFlickity();
    }
  }
}

// Initialize Flickity on page load if width is less than or equal to 768px
if ($(window).width() <= 768) {
  initFlickity();
}

// Add event listener to check window size on resize
$(window).on('resize', checkWindowSize);










let flktyNew;

function initFlickity1() {
  flktyNew = new Flickity('.tcw-featured-products-sports .tcw-featured-products-grid ', {
    // Flickity options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    groupCells: false, 
    percentPosition: false, 
    pageDots: false,
    prevNextButtons: false
  });
}

function destroyFlickity1() {
  if (flktyNew) {
    flktyNew.destroy();
    flktyNew = null;
  }
}

function checkWindowSize() {
  if ($(window).width() > 768) {
    destroyFlickity1();
  } else {
    if (!flktyNew) {
      initFlickity();
    }
  }
}

// Initialize Flickity on page load if width is less than or equal to 768px
if ($(window).width() <= 768) {
  initFlickity1();
}

// Add event listener to check window size on resize
$(window).on('resize', checkWindowSize);







let flktySport;

function initFlickity2() {
  flktySport = new Flickity('.tcw-featured-products-movie .tcw-featured-products-grid ', {
    // Flickity options
    cellAlign: 'left',
    contain: true,
    wrapAround: true,
    groupCells: false, 
    percentPosition: false, 
    pageDots: false,
    prevNextButtons: false
  });
}

function destroyFlickity2() {
  if (flktySport) {
    flktySport.destroy();
    flktySport = null;
  }
}

function checkWindowSize() {
  if ($(window).width() > 768) {
    destroyFlickity2();
  } else {
    if (!flktySport) {
      initFlickity2();
    }
  }
}

// Initialize Flickity on page load if width is less than or equal to 768px
if ($(window).width() <= 768) {
  initFlickity2();
}

// Add event listener to check window size on resize
$(window).on('resize', checkWindowSize);




$('.testimonials-slider').flickity({
  // options
  cellAlign: 'left',
  pageDots: true,
   wrapAround: true
});



$('.tcw-collection-grid ').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  pageDots: false,
  prevNextButtons: false,
  wrapAround: true
});



  function add_to_cart_grid(variantid,qty){
    var id = variantid;
    var q = qty;
    var ajax = {
        type: "POST",
        url: "/cart/add.js",
        data: "quantity=" + q + "&id=" + id,
        dataType: "json",
        success: function (n) {
          var cart = new theme.CartDrawer
          cart.init()
          cart.open();
        },
        error: function (n, c) {
           console.log('fail');
        }
     };
    jQuery.ajax(ajax)
  }



let flktyPP;

function initFlickityPP() {
  flktyPP = new Flickity('.tcw-product-images .tcw-product-img-grid', {
    // Flickity options
    cellAlign: 'center',
    contain: true,
    wrapAround: true,
    groupCells: false, 
    percentPosition: false, 
    pageDots: false,
    prevNextButtons: false
  });
}

function destroyFlickityPP() {
  if (flktyPP) {
    flktyPP.destroy();
    flktyPP = null;
  }
}

function checkWindowSizePP() {
  if ($(window).width() > 768) {
    destroyFlickityPP();
  } else {
    if (!flktyPP) {
      initFlickityPP();
    }
  }
}

// Initialize Flickity on page load if width is less than or equal to 768px
if ($(window).width() <= 768) {
  initFlickityPP();
}

// Add event listener to check window size on resize
$(window).on('resize', checkWindowSizePP);

















function destroyFlickityByClassIfLargeScreen(className, screenWidth) {
  var elements = document.querySelectorAll(className);
  elements.forEach(function(elem) {
    var flktyInstance = Flickity.data(elem);
    if (flktyInstance && window.innerWidth > screenWidth) {
      flktyInstance.destroy();
    }
  });
}

function checkAndDestroyFlickity() {
  destroyFlickityByClassIfLargeScreen('.tcw-product-img-grid', 768);
}

// Initial check
checkAndDestroyFlickity();

// Check on window resize
window.addEventListener('resize', checkAndDestroyFlickity);


document.querySelectorAll('.tcw-custom-product-template-info .variant__button-label.disabled').forEach(function(button) {
  button.addEventListener('click', function(event) {
    event.preventDefault();
  });
});


